import React, { useEffect, useRef } from 'react';
import { Animated, StyleSheet, View, ViewStyle } from 'react-native';
import theme from '../theme';
import { defaultScale } from '../utils/scaling';

interface IProps {
  fromValue: number;
  toValue: number;
  height?: number;
  width?: string |number;
  containerStyle?: ViewStyle;
  hasBorderRadius?: boolean;
  color?: string;
}

export const ProgressBar: React.FC<IProps> = ({
  fromValue,
  toValue,
  height = defaultScale(8),
  width = '100%',
  containerStyle,
  hasBorderRadius = true,
  color = theme.PRIMARY,
}) => {
  const animatedValue = useRef(new Animated.Value(fromValue)).current;
  const borderRadius = hasBorderRadius ? height / 2 : 0;
  useEffect(() => {
    Animated.timing(animatedValue, {
      toValue,
      duration: 500,
      useNativeDriver: false,
    }).start();
  }, [toValue]);

  const progressWidth = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0%', '100%'],
  });

  return (
    <View style={[styles.container, { height, width, borderRadius }, containerStyle]}>
      <Animated.View
        style={[styles.bar, { width: progressWidth, borderRadius, backgroundColor: color }]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    backgroundColor: theme.GREY_FIGMA_MEDIUM,
  },
  bar: {
    height: '100%',
    backgroundColor: theme.PRIMARY,
  },
});
